import AppContext from '@sportnet/ui/TheLayout/AppContext';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Api from '../../../../Api';
import Layout from '../../../../components/Layout';
import NscSyncStatus from '../../../../components/NscSyncStatus';
import { __ } from '../../../../utilities';
import { matchDefinition, PODefinition } from '../../definitions';
import { orgEntitySelector } from '../selectors';
import Tabber, { TABS } from '../Tabber';
import Segment from '@sportnet/ui/Segment';

const NscStatus = ({
  org,
  match: {
    params: { appspace },
  },
}) => {
  const { orgProfileId } = useParams();

  const fetchStatus = useCallback(() => {
    return Api.crmPPOIssSyncStatus(appspace, orgProfileId);
  }, [appspace, orgProfileId]);

  return (
    <Layout>
      <AppContext
        title={org && org.full_name}
        backUrl={`/admin/${appspace}/organizations`}
        breadcrumbs={[
          {
            name: __('Späť na zoznam'),
            url: `/admin/${appspace}/organizations`,
          },
        ]}
      />
      <Tabber activeTab={TABS.nsc} />
      <Segment noBottomGutter>
        <NscSyncStatus
          fetchStatus={fetchStatus}
          title={__('Stav synchronizácie s NŠC')}
        />
      </Segment>
    </Layout>
  );
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { organizationId },
    },
  },
) => ({
  org: orgEntitySelector(state, organizationId),
});

NscStatus.propTypes = {
  match: matchDefinition.isRequired,
  org: PODefinition,
};

NscStatus.defaultProps = {
  org: null,
};

export default connect(mapStateToProps)(NscStatus);
